/**
 * Where the SPA sends someone who needs a credential.
 *
 * pacmny-auth owns sign-in, invitations, password resets and address
 * confirmation — the SPA never handles a password — so the few places that have
 * to *point* at the provider need its origin. `oidcClient.js` resolves the same
 * value from the same variable but does not export it, and it is not this
 * module's file to change; both read `VUE_APP_OIDC_ISSUER`, so they cannot drift
 * apart without the deployment saying so.
 *
 * Only URLs that carry no token belong here. The invitation, reset and
 * verification links are `/credentials/{kind}/{selector}.{verifier}` and are
 * minted and mailed by pacmny-auth: a client that could construct one would have
 * defeated the point of them.
 */

const ISSUER = (process.env.VUE_APP_OIDC_ISSUER || 'http://localhost:8100').replace(/\/$/, '');

export const IDENTITY_PROVIDER_ORIGIN = ISSUER;

/**
 * The self-service page for "my invitation expired" and "I have forgotten my
 * password". It answers the same way whichever is true and whether or not the
 * address is known, so linking to it discloses nothing about who has an account.
 */
export const FORGOT_PASSWORD_URL = `${ISSUER}/password/forgot`;

export default { IDENTITY_PROVIDER_ORIGIN, FORGOT_PASSWORD_URL };
